import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "template-setting-window d-flex"
}
const _hoisted_2 = { style: {"width":"80vw","max-width":"80vw"} }
const _hoisted_3 = { class: "flex align-items-start justify-content-between no-wrap" }
const _hoisted_4 = { class: "text-subtitle2 margin-none" }
const _hoisted_5 = { class: "text-weight-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Настройка отчета", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = {
  style: {"max-height":"60vh"},
  class: "scroll"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  dense: "",
  rounded: "",
  class: "px-4 py-2 rounded bg-warning"
}, " Внимание: интервал будет округлен до суток. Временная зона - Сургут (+5) ", -1)
const _hoisted_10 = { class: "column q-my-sm not-excel" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "mark" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, " Формирование отчета с интервалом более 30 дней с детализацией суточных показателей ограничено ", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center padding-top-5" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Окончание настройки отчета")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = { align: "center" }
const _hoisted_18 = { class: "target-show-span" }

import { computed, inject, ref, reactive, watch } from 'vue';

import type { Props as TemplateProps } from './OilPressureTemplate.vue';
import OilPressure, {
  ReportCalculated,
  ReportOptions,
  ReportName,
} from '@/Template/OilPressure/OilPressure';

import { setElementColor_helper } from '@/helpers/main_helper'

interface Props {
  modelValue: boolean;
  objects: string[];
  interval: { from: Date; to: Date };
  reportName: ReportName;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OilPressureSettings',
  props: {
    modelValue: { type: Boolean },
    objects: { default: () => [] },
    interval: { default: () => ({
    from: new Date(),
    to: new Date(),
  }) },
    reportName: { default: () => 'oilPressure' }
  },
  emits: ['close', 'displayReport', 'update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: boolean, objects: string[], interval: { from: Date; to: Date }, reportName: ReportName }




const MAX_INTERVAL_DAYS = 30 * 24 * 60 * 60 * 1000;

const layout = computed({
  get() {
    return props.modelValue;
  },
  set(n) {
    emit('update:modelValue', n);
  },
});
const invalidInterval = computed(() => {
  const from = +props.interval.from;
  const to = +props.interval.to;

  const interval = to - from;

  return interval > MAX_INTERVAL_DAYS;
});

const LABEL = {
  default: 'Выполнить отчет',
  error: 'Ошибка',
};
const BANNER_DEFAULT = 'Обсчет данных для получения отчета';

const COLOR = {
  default: 'secondary',
  error: 'negative',
  success: 'positive',
};

const globalObjectsList = inject('globalObjectsList');

const executeButton = reactive({
  label: LABEL.default,
  color: COLOR.default,
  banner: BANNER_DEFAULT,
});

const summary = ref<boolean>(true);
const days = ref<boolean>(false);
const detail = ref<boolean>(false);

const AREA_ID = 'diagnostic-section-reports';

const title = computed(() =>
  props.reportName === 'oilPressure'
    ? 'Давление масла по парку ТС'
    : props.reportName === 'engineOilTemp' ? 'Моточасы работы ДВС по температуре масла ДВС' : 'Моточасы работы ДВС по температуре масла ретардера',
);

watch(layout, (isShow) => {
  if (
    isShow &&
    (props.reportName === 'engineOilTemp' ||
      props.reportName === 'retarderOilTemp')
  ) {
    executeReport();
  }
});

watch(
  () => invalidInterval.value,
  (isInvalid) => {
    if (isInvalid) {
      days.value = false;
    }
  },
);

function processCallback(type: string, message: string, percent?: number) {
  const button = document.getElementById(
    'diagnostics-get-template-button',
  );
  const buttonTarget = document.getElementsByClassName(
    'diagnostics-get-template-button-target-id',
  )[0];

  if (type === 'error') {
    const defaultErrorMessage =
      'Произошла ошибка, попробуйте повторить запрос, либо обновить страницу';
    if (buttonTarget) {
      infoShowText_helper(
        buttonTarget,
        message || defaultErrorMessage,
        AREA_ID,
      );
      setElementColor_helper(button, 'red');
    }
  } else {
    if (buttonTarget) {
      infoShowText_helper(buttonTarget, message, AREA_ID);
      setElementColor_helper(button, 'blue');
    }
  }
}

function executeReport() {
  if (!summary.value && !days.value && !detail.value) {
    executeButton.label = LABEL.error;
    executeButton.color = COLOR.error;
    executeButton.banner = 'Необходимо отметить хотя бы один параметр';
    return;
  }

  const report = new OilPressure(props.reportName);
  report.onProcess(processCallback);
  report.onSuccess((reportCalculated: TemplateProps['data']) => {
    reportCalculated.objects.sort((a, b) => a.id.localeCompare(b.id));
    const button = document.getElementById(
      'diagnostics-get-template-button',
    );
    const buttonTarget = document.getElementsByClassName(
      'diagnostics-get-template-button-target-id',
    )[0];

    const area = document.getElementById(AREA_ID);
    if (area) area.innerHTML = '';
    
    buttonTarget.innerHTML = 'Суммарный отчет построен. Выполнить новый запрос?';
    setElementColor_helper(button, 'green');
    reportCalculated.isSummary = summary.value;
    reportCalculated.isDays = days.value;
    emit('displayReport', reportCalculated);

    const switchToReportAreaButton = document.getElementById(
      'ui-button-diagnostics-report',
    );
    if (
      switchToReportAreaButton &&
      !switchToReportAreaButton.classList.contains('btn-primary')
    ) {
      switchToReportAreaButton.classList.add('btn-success');
    }
  });

  const objectsData = props.objects.reduce(
    (acc: ReportOptions['objectsData'], id: string) => {
      const object = globalObjectsList[id];
      if (!object) return acc;

      acc[id] = {
        name: object.name,
        stateNumber: object.stateNumber,
      };
      return acc;
    },
    {},
  );

  report.getReport({
    objects: props.objects,
    from: +props.interval.from,
    to: +props.interval.to,
    objectsData,
    isSummary: summary.value,
    isDays: days.value,
  });

  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_unref(layout))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(title)), 1),
              _hoisted_6
            ]),
            _createElementVNode("img", {
              class: "close",
              src: "/images/close.png",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            })
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, [
                _createTextVNode(" Суммарные показатели "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((summary).value = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, summary.value]
                ])
              ]),
              _hoisted_11,
              _createElementVNode("label", null, [
                _createTextVNode(" Суточные показатели "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((days).value = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, days.value]
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_14, 512), [
              [_vShow, _unref(invalidInterval)]
            ]),
            _hoisted_15
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              style: _normalizeStyle({ color: executeButton.color }),
              onClick: executeReport
            }, _toDisplayString(executeButton.label), 5),
            _createElementVNode("div", _hoisted_18, _toDisplayString(executeButton.banner), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})